export default __webpack_public_path__ + "static/media/pdPreview.9ea1a028.jpg";